import { Injectable } from '@angular/core';

import { DropDownModel } from '../../models/dropDownModel';
import { BaseApiService } from '../base-api.service';
import { PSCData, UnspscData, Vendor } from '../cccReport/ccc-report.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class SearchParametersService {
  UnspscCodes: Promise<UnspscData[]>;
  MismatchedUnspscCodes: Promise<UnspscData[]>;
  PSCDescriptions: Promise<PSCData[]>;
  Vendors: Promise<Vendor[]>;
  SyncCodeData: Promise<SyncCodeData[]>;
  token = '';
  baseUrl = window.location.origin;

  constructor(
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });

    this.UnspscCodes = this.getUnspscCodes();
    this.MismatchedUnspscCodes = this.getMismatchedUnspscCodes();
    this.PSCDescriptions = this.getPscDescriptions();
    this.Vendors = this.getVendors();
    this.SyncCodeData = this.getSyncCodes();
  }

  //#region Search Functions
  getKnownSources(): Promise<DropDownModel[]> {
    let url = this.baseUrl + '/api/Search/Sources';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<DropDownModel[]>(url);
  }

  private getSyncCodes(): Promise<SyncCodeData[]> {
    let url = this.baseUrl + '/api/TypeAheadData/GetSyncCodes';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<SyncCodeData[]>(url);
  }

  private getMismatchedUnspscCodes(): Promise<UnspscData[]> {
    let url = this.baseUrl + '/api/TypeAheadData/GetMismatchedUnspscCodes';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<UnspscData[]>(url);
  }

  private getUnspscCodes(): Promise<UnspscData[]> {
    let url = this.baseUrl + '/api/TypeAheadData/GetUnspscCodes';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<UnspscData[]>(url);
  }

  private getPscDescriptions(): Promise<PSCData[]> {
    let url = this.baseUrl + '/api/TypeAheadData/GetPSCDescriptions';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<PSCData[]>(url);
  }

  private getVendors(): Promise<Vendor[]> {
    let url = this.baseUrl + '/api/TypeAheadData/GetVendors';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<Vendor[]>(url);
  }
}

export interface SyncCodeData {
  subCategoryDescription: string;
  groupDescription: string;
  syncCode: string;
}
